// ----------------------------------------------------------------------

export default function Fab(theme) {
  return {
    MuiFab: {
      defaultProps: {
        color: 'primary',
      },

      styleOverrides: {
        root: {
          boxShadow: 'none',
          fontWeight: 600,
          'fontSize': '12px',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        primary: {
          backgroundColor: theme.palette.primary.palette[50],
          '&:hover': {
            backgroundColor: theme.palette.primary.palette[100],
            color: theme.palette.primary.main,
          },
        },
        secondary: {
          '&:hover': {
            backgroundColor: theme.palette.secondary.dark,
          },
        },
        extended: {
          backgroundColor: theme.palette.background.default,
          color: theme.palette.primary.main,
          border: `solid 1px ${theme.palette.primary.main}`,
          boxShadow: 'none',
          '& svg': {
            marginRight: theme.spacing(1),
          },
          '&:hover': {
            boxShadow: 'none',
            color: theme.palette.primary.contrastText,
          },
        },
      },
    },
  };
}
